import axios from "axios"

// const BASE_URL = "https://backend.taih.ai/api/auth"
const URL = process.env.REACT_APP_API_URL

const BASE_URL = `${URL}/api/auth`

console.log(BASE_URL)
export const AuthApis = {
    login: async(data) => {
        return axios.post(`${BASE_URL}/login`, data)
    },
}
